import { LoadingButton as AtlasButton } from '@atlaskit/button';
import styles from './Button.module.sass';

export interface ButtonProps {
	children: any;
}

const Button = ({children, appearance, ...props}: any) => {
    return (
        <AtlasButton
            className={appearance === 'primary' ? styles['primary'] : styles['standard']}
            appearance={appearance}
            style={{opacity: props?.isDisabled ? .4 : 1}}
            {...props}>
            { children }
        </AtlasButton>
    )
}

export default Button;